import { Breadcrumb, Typography } from 'antd-v5';
import React from 'react';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;

const Header = ({ headerStyles, breadcrumb, title, maxWidth, actions, description }) => {
  return (
    <div
      className="flex-row-spacebetween-center m-btm-10 m-top-10 p-left-40 p-right-40"
      style={{
        maxWidth: maxWidth ?? '1200px',
        height: 'auto',
        ...headerStyles,
      }}
    >
      <div className="flex-col-left">
        <Breadcrumb itemRender={itemRender} items={breadcrumb} />
        <Title
          className="m-top-16"
          level={2}
          style={{
            fontFamily: 'Poppins',
            fontSize: '20px',
            fontWeight: 600,
            color: 'var(--clientbook-dark, #1A2520)',
            marginBottom: description ? '4px' : undefined,
          }}
        >
          {title}
        </Title>
        {description && (
          <Text style={{ fontSize: '13px', color: '#6B7280' }}>
            {description}
          </Text>
        )}
      </div>
      {actions && <div className="flex-row-center">{actions}</div>}
    </div>
  );
};

function itemRender(currentRoute, params, items) {
  const currentIndex = items.findIndex(item => item === currentRoute);
  const isLast = currentIndex === items.length - 1;

  // If no path or is the last item, render as plain text (not clickable)
  if (!currentRoute.path || isLast) {
    return <span>{currentRoute.title}</span>;
  }

  // Render as link using the item's path directly
  return <Link to={currentRoute.path}>{currentRoute.title}</Link>;
}

export default Header;
